import { createContext } from "react";
import { WebSocketContextData } from "./types";

export const WebSocketContext = createContext({} as WebSocketContextData);
